module.exports = __webpack_public_path__ + "img/Speaker=Alison Adnani.f6ceef55.png";